// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__YmQtH","inner":"Form_inner__3O3wZ","range":"Form_range__2oLHh","name":"Form_name__1oixl","actions":"Form_actions__2esb5"};